import React, { memo } from "react";
import { AppModal, Col, Row, UiBox, UiFlex, UiIcon, UiPrimaryButton, UiText } from "~/components/elements";
import { ModalProps } from "~/types/general";
import { UPLOAD_TIPS_BAD_PHOTOS, UPLOAD_TIPS_GOOD_PHOTOS } from "~/constants/dashboard";
import { TipBox, TipNotice } from "~/pages/dashboard/upload-step/UploadTipsPage";
import { AiOutlineClose } from "react-icons/ai";

interface Props extends ModalProps {}

function ModalAction({ onClickAction }: { onClickAction: () => void }) {
  return (
    <UiBox
      fontSize="sm"
      fontWeight="bold"
      border="1px solid"
      borderColor="orange.300"
      color="orange.300"
      paddingY={1}
      paddingX={4}
      borderRadius="lg"
      marginRight={2}
      backgroundColor="white"
      cursor="pointer"
      onClick={onClickAction}
    >
      Got it
    </UiBox>
  );
}

function Handler({ defaultValue, visible, onClose }: Props) {
  const initialRef = React.useRef(null);

  const onCloseModal = () => {
    onClose();
  };

  return !visible ? null : (
    <AppModal
      initialFocusRef={initialRef}
      isOpen={visible}
      onClose={onCloseModal}
      header={null}
      showRightConnerCloseButton={false}
      showFooter={false}
      trapFocus={false}
      scrollBehavior="outside"
      // actions={<ModalAction onClickAction={onCloseModal} />}
    >
      <Col py={4}>
        <UiBox w="full">
          <Row align="center" justify="space-between">
            <UiText vr="title1" textAlign="left">
              Important Information to Create Great Photoshoots
            </UiText>
            <UiBox bg="transparent" onClick={onClose} _hover={{ cursor: "pointer" }}>
              <UiIcon as={AiOutlineClose} mx={0} />
            </UiBox>
          </Row>
          <UiText vr="body3" mt={{ base: 2, sm: 3 }} textAlign="left">
            Carefully read the photo recommendations below to ensure that you get the best photoshoots.
          </UiText>
        </UiBox>
        <UiFlex flexDirection={{ base: "column-reverse", lg: "row" }} gap={{ base: 2, lg: 5 }} mt={{ base: 4, lg: 8 }}>
          <TipBox images={UPLOAD_TIPS_BAD_PHOTOS.images} tips={UPLOAD_TIPS_BAD_PHOTOS.content} type="bad" />
          <TipBox images={UPLOAD_TIPS_GOOD_PHOTOS.images} tips={UPLOAD_TIPS_GOOD_PHOTOS.content} type="good" />
        </UiFlex>
        <TipNotice bg="lightblue" />
        <UiPrimaryButton
          whiteSpace="normal"
          lineHeight="20px"
          py={3}
          h="auto"
          w="full"
          mx="auto"
          mt={{ base: 3, lg: 8 }}
          onClick={onClose}
        >
          Got it
        </UiPrimaryButton>
      </Col>
    </AppModal>
  );
}

function DisclaimerModal({ visible, destroyOnClose = true, ...rest }: Props) {
  if (destroyOnClose) {
    return visible ? <Handler visible {...rest} /> : null;
  }
  return <Handler visible={visible} {...rest} />;
}

export default memo(DisclaimerModal);
